export const ConnectionDialogTranslationsDictionary =
{
    connectionDialogTitle: "Connection",
    banner: {
        networkTitle: "No connection to the vehicle",
        networkContent: "Ensure that the telematics device is communicating.",
        malfunctionTitle: "Malfunctions",
        malfunctionContent: "The electronic logging device (ELD) has detected internal diagnostic errors or malfunctions. You may be non-compliant."
    },
    networkDisconnectedDetail: {
        title: "Network disconnected",
        paragraphOne: "Either this device couldn't connect to the server or the telematics device isn't properly configured. Ensure that:",
        bulletPointOne: "Airplane mode is off",
        bulletPointTwo: "This device is connected to the Internet",
        bulletPointThree: "The telematics device is plugged in and communicating"
    },
    gpsDisconnectedDetail: {
        title: "GPS disconnected",
        paragraphOne: "The GPS signal may be weak or this device's GPS functionality may not be enabled. Ensure that:",
        bulletPointOne: "Airplane mode is off",
        bulletPointTwo: "Location services are on and set to \"High Accuracy\" (iOS)"
    },
    contactYourAdmin: "For any questions or concerns, contact your administrator",
    noVehicle: "No vehicle",
    vehicleDisconnected: "Vehicle disconnected",
    vehicleConnected: "Vehicle connected",
    geotabDriveDisconnected: "Geotab Drive disconnected",
    geotabDriveConnected: "Geotab Drive connected",
    gpsDisconnected: "GPS disconnected",
    gpsConnected: "GPS connected",
    malfunctions: "Malfunction(s)",
    noMalfunctions: "No malfunctions"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in ConnectionDialogTranslationsDictionary) {
        r.push(ConnectionDialogTranslationsDictionary[prop]);
    }
    return r;
};

export const ConnectionDialogTranslations = getTranslations();